import { openDB } from 'idb';
const DB_NAME = 'BeeyFELogsDB';
const DB_VERSION = 1;
const STORE_NAME = 'logs';
class LogStorage {
    constructor() {
        this.dbPromise = openDB(DB_NAME, DB_VERSION, {
            upgrade(db) {
                if (!db.objectStoreNames.contains(STORE_NAME)) {
                    const store = db.createObjectStore(STORE_NAME, {
                        keyPath: 'id',
                        autoIncrement: true,
                    });
                    store.createIndex('timestamp', 'timestamp');
                }
            },
        });
    }
    async saveLogItem(log) {
        try {
            const db = await this.dbPromise;
            await db.add(STORE_NAME, log);
        }
        catch (error) {
            // eslint-disable-next-line no-console
            console.error('Failed to save log to IndexedDB:', error, log);
        }
    }
    async getAllLogs() {
        const db = await this.dbPromise;
        const logs = await db.getAll(STORE_NAME);
        return logs.filter((log) => 'id' in log);
    }
    async deleteLogs(ids) {
        const db = await this.dbPromise;
        const transaction = db.transaction(STORE_NAME, 'readwrite');
        await Promise.all([
            ...ids.map((id) => transaction.store.delete(id)),
            transaction.done,
        ]);
    }
    async clear() {
        const db = await this.dbPromise;
        await db.clear(STORE_NAME);
    }
    async getCount() {
        const db = await this.dbPromise;
        return db.count(STORE_NAME);
    }
}
export const logStorage = new LogStorage();
